import ProgressBar from '@luminopia/react-toolbox/lib/progress_bar'
import * as React from 'react'
import {connect, Dispatch} from 'react-redux'
import {RouteComponentProps} from 'react-router'
import Card from 'study_coordinator/components/Card'
import {IFormFields, prescriptionFormFactory} from 'study_coordinator/components/prescription'
import {
  createPrescriptionRequest,
  getStudyCoordinatorRequest,
  getSubjectsRequest,
  IState,
} from 'study_coordinator/store'

const formName = 'CreatePrescriptionPagePrescriptionForm'
const PrescriptionForm = prescriptionFormFactory(formName)

export interface IRouteParams {
  subjectIdentifier: string
}

interface IStateProps {
  subjectIdentifier: string
  isFetching: boolean
}

interface IDispatchProps {
  onSubmit: (data: IFormFields) => void
  onMount: () => void
}

interface IOwnProps extends RouteComponentProps<IRouteParams> {}

export interface IProps extends IStateProps, IDispatchProps, IOwnProps {}

export class CreatePrescriptionPage extends React.Component<IProps, {}> {
  public render() {
    if (this.props.isFetching) {
      return <ProgressBar type='circular' mode='indeterminate' multicolor />
    }

    return (
      <div>
        <Card
          title='Create prescription'
          subtitle={`Patient ${this.props.subjectIdentifier}`}
          icon='assignment'
        >
          <PrescriptionForm
            subjectIdentifier={this.props.subjectIdentifier}
            onSubmit={this.props.onSubmit}
          />
        </Card>
      </div>
    )
  }

  public componentDidMount() {
    this.props.onMount()
  }
}

const mapStateToProps = (state: IState, ownProps: IOwnProps): IStateProps => {
  const subjectIdentifier = ownProps.match.params.subjectIdentifier
  const isFetching = state.subjects.isFetching || state.studyCoordinator.isFetching
  return {
    subjectIdentifier,
    isFetching,
  }
}

const mapDispatchToProps = (dispatch: Dispatch<void>, ownProps: IOwnProps): IDispatchProps => ({
  onSubmit: (data: IFormFields) => dispatch(createPrescriptionRequest(data, formName)),
  onMount: () => {
    dispatch(getSubjectsRequest())
    dispatch(getStudyCoordinatorRequest())
  },
})

export default connect<IStateProps, IDispatchProps, IOwnProps, IState>(
  mapStateToProps,
  mapDispatchToProps,
)(CreatePrescriptionPage)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/pages/CreatePrescriptionPage.tsx